module.exports = __webpack_public_path__ + "static/media/bg7.be7eaa32.jpg";